import { render, staticRenderFns } from "./BottomFixed.vue?vue&type=template&id=14c1fcda&scoped=true&"
import script from "./BottomFixed.vue?vue&type=script&lang=js&"
export * from "./BottomFixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c1fcda",
  null
  
)

export default component.exports